import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import TicketsDisplay from './TicketsDisplay';
import { scrollToField } from '../helpers/form-scroll-helper';
import { isEmpty } from '../../utils/obj-utils';

class TicketGroups extends Component {
    constructor(props) {
        super(props);
        this.formReferences = {};
        const { ticketGroups } = props;

        this.formReferences = ticketGroups.reduce((acc, ticketGroup) => {
            acc[ticketGroup.productName] = React.createRef();
            return acc;
        }, {});
    }

    componentWillReceiveProps(nextProps) {
        const { scrollTo } = nextProps;
        if (!isEmpty(scrollTo)) {
            scrollToField(scrollTo.productName);
        }
    }

    componentDidMount() {
        const { scrollTo } = this.props;
        if (!isEmpty(scrollTo)) {
            const scrollToRef = this.formReferences[scrollTo.productName];
            scrollToField(scrollToRef);
        }
    }

    render() {
        const { ticketGroups, formData, onSaveAndContinueClick } = this.props;
        return ticketGroups.map((ticketGroup, index) => {
            const {
                ticketEvent,
                productName,
                quantity,
                tickets
            } = ticketGroup;
            const isLast = index === ticketGroups.length - 1;

            return (
                <div
                    ref={this.formReferences[productName]}
                    key={index}
                    className={`date-container ${isLast ? 'last' : formMessageConstants.emptyString}`}>
                    <div className='header'>
                        <svg
                            aria-hidden='true'
                            focusable='false'
                            data-prefix='far'
                            data-icon='calendar-alt'
                            role='img'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 448 512'
                            className='icon-calendar'>
                            <path
                                fill='#2269AB'
                                d='M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z'
                                className=''>
                            </path>
                        </svg>
                        <div className='info'>
                            <p className='sub-title'>{productName}</p>
                            <p className='championship'>{ticketEvent.eventName}</p>
                            <p className='location'>{ticketEvent.eventLocation}</p>
                        </div>
                    </div>
                    <div className='number-of-tickets'>{`${quantity} ticket(s) available`}</div>
                    <TicketsDisplay
                        formData={formData}
                        tickets={tickets}
                        onSaveAndContinueClick={onSaveAndContinueClick}></TicketsDisplay>
                </div>);
        });
    }
}


TicketGroups.propTypes = {
    ticketGroups: PropTypes.array.isRequired,
    formData: PropTypes.object.isRequired,
    scrollTo: PropTypes.object.isRequired,
    onSaveAndContinueClick: PropTypes.func.isRequired,
};

export default TicketGroups;
